import React, { useContext } from "react";
import styles from "./Paths.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "shared/components/Buttons/Button";
import { DoneRounded } from "@material-ui/icons";
import { Link } from "react-router-dom";
import challengePaths from "./challengePaths";
import AppContext from "context/AppContext";
import PageRow from "shared/components/PageRow/PageRow";
import CardStep from "shared/components/CardStep/CardStep";
import { Paths as routePaths } from "shared/types/navigation";

const steps = [
  {
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/devchallenges-1234.appspot.com/o/step_1_sm.png?alt=media&token=23ae059d-ed3d-4d35-bf72-2889c74b1536",
    title: "Step 1: Choose a challenge",
    description:
      "Choose a challenge, read the description carefully. Paths help you navigate, and you can earn a certificate after completing all challenges in the path",
  },
  {
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/devchallenges-1234.appspot.com/o/step_2_sm.png?alt=media&token=ab9527b4-22d1-4656-a8d1-cff7bef28faf",
    title: "Step 2: Work by yourself or with a team",
    description:
      "All challenges can be completed by one person, but teamwork is important at workplaces. If the challenge is too big for you, ask a friend to join.",
  },
  {
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/devchallenges-1234.appspot.com/o/step_3_sm.png?alt=media&token=1a6faf63-08b9-4a9d-8821-45e0cb5f630a",
    title: "Step 3: Submit your solutions and give feedback",
    description:
      "When you complete the challenge, submit your solution. You can also check if there is an existing solution and give them some feedback.",
  },
];

const Paths = () => {
  const { state } = useContext(AppContext);

  return (
    <div className={styles.paths}>
      {(!state.user?.solutionsCount || state.user?.solutionsCount <= 0) &&
        !state.loadingUser && (
          <PageRow>
            <h1>Welcome to DevChallenges</h1>

            <Grid container direction="row" spacing={3}>
              {steps.map(({ imgSrc, title, description }) => {
                return (
                  <Grid item xs={12} md={6} lg={4} key={title}>
                    <CardStep
                      imgSrc={imgSrc}
                      title={title}
                      description={description}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </PageRow>
        )}

      <div className={styles.paths_heading}>
        <h1>Challenge Paths</h1>

        <Link to={routePaths.challenges}>
          <Button size="small" buttonVariant="default">
            All Challenges
          </Button>
        </Link>
      </div>

      <Grid container spacing={3}>
        {challengePaths.map(({ includes, imgSrc, name, intro, id, status }) => (
          <Grid item xs={12} sm={6} md={4} key={name}>
            <Link to={status !== "in-progress" ? `paths/${id}` : "/paths"}>
              <div className={styles.paths_card}>
                <img loading="lazy" src={imgSrc} alt={name} />
                <h4>{name}</h4>

                <p className={styles.paths_card_description}>{intro}</p>

                <div className={styles.paths_includes}>
                  <h6 className={styles.paths_includes_heading}>Includes:</h6>
                  <ul>
                    {includes.map((text) => (
                      <li className={styles.paths_includes_item} key={text}>
                        <DoneRounded fontSize="inherit" color="inherit" />
                        <p>{text}</p>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className={styles.paths_card_buttons}>
                  {status === "in-progress" ? (
                    <Button
                      buttonVariant="default"
                      disabled
                      aria-label="coming soon"
                    >
                      Coming Soon
                    </Button>
                  ) : (
                    <Button aria-label="view challenge" buttonVariant="primary">
                      View Challenge Path
                    </Button>
                  )}
                </div>
              </div>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Paths;
